module.exports = __webpack_public_path__ + "img/index-solution-01.d796e07d.jpg";